import { type ImportJobListItem } from '@utazzo/shared';
import React from 'react';

/**
 * Six-tile counter strip used by both the leads and hotels importers.
 * Each tile shows one row-status bucket from the job.
 */
export const JobSummary = ({ job }: { job: ImportJobListItem }): React.JSX.Element => (
  <div className="grid grid-cols-2 gap-2 sm:grid-cols-6">
    <Counter label="Total" value={job.totalRows} />
    <Counter label="Valid" value={job.validRows} tone="open" />
    <Counter label="Invalid" value={job.invalidRows} tone="warning" />
    <Counter label="Skipped" value={job.skippedRows} tone="neutral" />
    <Counter label="Committed" value={job.committedRows} tone="won" />
    <Counter label="Failed" value={job.failedRows} tone="lost" />
  </div>
);

const TONE_BG = {
  neutral: 'border-zinc-200 bg-white',
  open: 'border-blue-100 bg-blue-50/60',
  won: 'border-emerald-100 bg-emerald-50/60',
  lost: 'border-red-100 bg-red-50/60',
  warning: 'border-amber-100 bg-amber-50/60',
} as const;

const Counter = ({
  label,
  value,
  tone = 'neutral',
}: {
  label: string;
  value: number;
  tone?: keyof typeof TONE_BG;
}): React.JSX.Element => (
  <div className={`rounded-md border ${TONE_BG[tone]} px-3 py-2`}>
    <div className="text-xl font-semibold text-zinc-900">{value.toLocaleString('en-IN')}</div>
    <div className="text-xs text-zinc-600">{label}</div>
  </div>
);
